// extracted by mini-css-extract-plugin
export default {"profileLink":"ProfileLinkLayout_profileLink__eEPHI"};